//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UpdateLanguage } from '@/api/permission/userSetting';
import getPageTitle from '@/utils/get-page-title';
export default {
  computed: {
    language: function language() {
      return this.$store.getters.language;
    }
  },
  methods: {
    handleSetLanguage: function handleSetLanguage(lang) {
      UpdateLanguage({
        language: lang
      }).then(function (res) {});
      this.$i18n.locale = lang;
      this.$store.dispatch('app/setLanguage', lang);
      var text = '切换成功';
      if (lang === 'en') text = 'Switch Language Success';
      if (lang === 'zhtw') text = '切換成功';
      document.title = getPageTitle(this.$route.meta.title, this.$route.meta.zhTitle);
      this.$message({
        message: text,
        type: 'success'
      });
    }
  }
};